import { render, staticRenderFns } from "./accountantSummaryDriverCapital.vue?vue&type=template&id=d70f6652"
import script from "./accountantSummaryDriverCapital.vue?vue&type=script&lang=js"
export * from "./accountantSummaryDriverCapital.vue?vue&type=script&lang=js"
import style0 from "./accountantSummaryDriverCapital.vue?vue&type=style&index=0&id=d70f6652&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports